import EventBus from "@plugins/common/service/eventbus";
export const TopicResourceEventBus = new EventBus();
